export function isInvalidCredentialsErrorObject(error: any): boolean {
  if (!(error.errors instanceof Array)) return false;
  if (!error.errors.length || error.errors.length > 1) return false;
  if (!error.errors[0].extensions?.code) return false;

  return error.errors[0].extensions!.code === "INVALID_CREDENTIALS";
}

